import { Link, useLocation, useNavigate } from "react-router-dom";
import { usePublicPanel } from "../../api/hooks";
import { usePanelContext } from "../../panelContext";
import { usePanelPath } from "../../routing";
import type { Panelist } from "../../types";
import { activeNavKey, formatNumber, initials, walletState } from "../../utils";
import { formatDate } from "../../utils/dates";
import { EarningsIcon, ProfileIcon, TasksIcon } from "../ui/Icons";

interface SidebarProps {
  onClose?: () => void;
  panelist: Panelist;
  taskCount: number;
}

export function Sidebar({ onClose, panelist, taskCount }: SidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const panelPath = usePanelPath();
  const publicPanelQuery = usePublicPanel();
  const activeKey = activeNavKey(location.pathname);
  const wallet = walletState(publicPanelQuery.data, panelist.points);
  const userInitials = initials(panelist.firstName, panelist.lastName);
  const { panelName, panelTagline } = usePanelContext();

  return (
    <aside className="sidebar">
      <Link className="sb-logo" onClick={onClose} to={panelPath("")}>
        <div className="sb-logo-name">{panelName}</div>
        <div className="sb-logo-sub">{panelTagline}</div>
      </Link>

      <div className="sb-user">
        <div className="avatar">{userInitials}</div>
        <div>
          <div className="sb-user-name">
            {panelist.firstName} {panelist.lastName}
          </div>
          <div className="sb-user-since">
            Member since {formatDate(panelist.memberSince)}
          </div>
        </div>
      </div>

      <nav className="sb-nav" aria-label="Main navigation">
        <div className="sb-nav-label">Menu</div>
        <Link
          className={`sb-item ${activeKey === "/" ? "active" : ""}`}
          onClick={onClose}
          to={panelPath("/")}
        >
          <TasksIcon />
          Tasks
          {/* <span className="sb-badge">{taskCount}</span> */}
        </Link>
        {/* <Link
          className={`sb-item ${activeKey === "dashboard" ? "active" : ""}`}
          onClick={onClose}
          to={panelPath("/dashboard")}
        >
          <DashboardIcon />
          Dashboard
        </Link> */}
        {/* <Link
          className={`sb-item ${activeKey === "tasks" ? "active" : ""}`}
          onClick={onClose}
          to={panelPath("/tasks")}
        >
          <TasksIcon />
          Available tasks
          <span className="sb-badge">{taskCount}</span>
        </Link> */}
        <Link
          className={`sb-item ${activeKey === "earnings" ? "active" : ""}`}
          onClick={onClose}
          to={panelPath("/earnings")}
        >
          <EarningsIcon />
          Earnings history
        </Link>
        <Link
          className={`sb-item ${activeKey === "profile" ? "active" : ""}`}
          onClick={onClose}
          to={panelPath("/profile")}
        >
          <ProfileIcon />
          My profile
        </Link>
        <div className="sb-nav-label" style={{ marginTop: 8 }} />
      </nav>

      <div className="sb-wallet">
        <div className="sb-wallet-lbl">Your balance</div>
        <div className="sb-wallet-pts">{formatNumber(panelist.points)} pts</div>
        <div className="sb-wallet-gbp">≈ {panelist.pointsGbp}</div>
        <div className="sb-progress">
          <div
            className="sb-progress-fill"
            style={{ width: `${wallet.pct}%` }}
          />
        </div>
        <div className="sb-wallet-sub">
          {wallet.canCashout
            ? "Minimum reached — ready to cash out"
            : `${formatNumber(wallet.toNext)} pts to cashout`}
        </div>
        <button
          className="sb-cashout-btn"
          // disabled={!wallet.canCashout}
          onClick={() => {
            onClose?.();
            navigate(panelPath("/earnings"));
          }}
          type="button"
        >
          Go to earnings →
        </button>
      </div>
    </aside>
  );
}
